<template>
  <div class="AddDefineInfoSystem">
    <div class="card text-center">
      <div class="card-header" :class="ThemeTitleModal">
        <ul
          class="nav nav-tabs mt-3 card-header-tabs"
          id="myTab"
          role="tablist"
          dir="rtl"
        >
          <li class="nav-item">
            <a
              class="nav-link active"
              id="Detail-tab"
              data-toggle="tab"
              href="#Detailtab"
              role="tab"
              aria-controls="Detailtab"
              aria-selected="true"
              >سیستم های اطلاعاتی</a
            >
          </li>
        </ul>
      </div>
      <div class="tab-content" id="Controler">
        <div
          class="tab-pane fade show active"
          id="Detailtab"
          role="tabpanel"
          aria-labelledby="Detail-tab"
        >
          <div id="Controler">
            <div class="container mt-3 mb-3 text-right">
              <div class="row">
                <div class="col-lg-3 col-12">
                  <span>نسخه سیستم</span>
                  <input
                    type="text"
                    class="form-control InputText"
                    v-model="DataAxios.SysVersion"
                  />
                </div>
                <div class="col-lg-6 col-12 text-right">
                  <span>نسخه بانک اطلاعاتی</span>
                  <input
                    type="text"
                    class="form-control InputText"
                    v-model="DataAxios.Dbversion"
                  />
                </div>
                <div class="col-lg-3 col-12 text-right">
                  <span>تجمیعی</span>
                  <span class="form-control p-1">
                    <div class="custom-control custom-switch">
                      <input
                        type="checkbox"
                        class="custom-control-input InputText"
                        id="Tajmie"
                        @click="statusChk($event)"
                        :value="Tajmie"
                      />
                      <label class="custom-control-label" for="Tajmie"
                        >تجمیعی</label
                      >
                    </div>
                  </span>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-lg-6 col-12 text-right">
                  <span>نام نرم افزار</span>
                  <select class="form-control" v-model="Selected">
                    <option value="0">
                      <span> نام نرم افزار را انتخاب کنید</span>
                    </option>
                    <option
                      v-for="item in this.$store.state.DefineInfoSystem
                        .DataSoftWare"
                      :key="item.Id"
                      :value="item.Id"
                    >
                      <span>{{ item.SoftName }}</span>
                    </option>
                  </select>
                </div>
                <div class="col-lg-6 col-12 text-right">
                  <span>نام سیستم های اطلاعاتی</span>
                  <input
                    type="text"
                    class="form-control InputText"
                    v-model="DataAxios.Dbname"
                  />
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-lg-6 col-12 text-right">
                  <span>نام بانک سیستم</span>
                  <input
                    type="text"
                    class="form-control InputText"
                    v-model="DataAxios.SystemName"
                  />
                </div>
                <div class="col-lg-6 col-12 text-right">
                  <span>نام بانک تصاویر</span>
                  <input
                    type="text"
                    class="form-control InputText"
                    v-model="DataAxios.ImageDbname"
                  />
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-lg-6 col-12 text-right">
                  <span>نام بانک رویداد ها</span>
                  <input
                    type="text"
                    class="form-control InputText"
                    v-model="DataAxios.LogDbname"
                  />
                </div>
                <div class="col-lg-6 col-12 text-right">
                  <span>نام بانک اینترنت بانک</span>
                  <input
                    type="text"
                    class="form-control InputText"
                    v-model="DataAxios.WebDbname"
                  />
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-lg-12 col-12 text-right">
                  <span>آدرس سرور داشبورد</span>
                  <input
                    type="text"
                    class="form-control InputText"
                    v-model="DataAxios.DashboardUrl"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <button-edit-data
        class="mb-3 mr-2"
        :DataParanet="DataAxios"
      ></button-edit-data>
      <div v-for="Dataa in EditData" :key="Dataa.id"></div>
    </div>
  </div>
</template>
<script>
import ButtonEditData from "../Tools/ButtonEditData.vue";
export default {
  components: { ButtonEditData },
  data() {
    return {
      Theme: "bg-BlueGreen",
      DataAxios: null,
      EditData: this.$store.state.DefineInfoSystem.EditData,
      InnerData: {
        ArryfildValue: null,
        Method: "get",
        Action: "CmbSoftware",
        Token: this.$session.get("Token"),
        From: "Body",
      },
    };
  },
  computed: {
    ThemeTitleModal() {
      return this.$store.state.ThemeModal;
    },
    Selected: {
      get() {
        return this.$store.state.DefineInfoSystem.EditData[0].TblSoftwareId;
      },
      set(value) {
        this.$store.state.DefineInfoSystem.EditData[0].TblSoftwareId = value;
      },
    },
    Tajmie: {
      get() {
        return this.$store.state.DefineInfoSystem.EditData[0].Tajmie;
      },
      set(value) {
        this.$store.state.DefineInfoSystem.EditData[0].Tajmie = value;
      },
    },
  },
  methods: {
    statusChk: function (event) {
      var targetId = event.currentTarget.id;
      var checkBox = document.getElementById(targetId);
      if (checkBox.id == "Tajmie") {
        if (checkBox.checked == true) {
          this.DataAxios.Tajmie = true;
        } else {
          this.DataAxios.Tajmie = false;
        }
      }
    },
  },
  created() {
    let info;
    let list = [];
    for (let index = 0; index < this.EditData.length; index++) {
      info = this.EditData[index];
      list.push(info);
    }
    this.$myAxiosGetSoftware(this.InnerData);
    this.DataAxios = list[0];
    this.DataAxios["FromAutoNightJob"] = "01:30";
    this.DataAxios["ToAutoNightJob"] = "01:30";
    this.DataAxios["HarAutoNightJob"] = 24;
    this.DataAxios["FromAutoReIndex"] = "24";
    this.DataAxios["ToAutoReIndex"] = "24";
    console.log(this.DataAxios);
  },
};
</script>
<style scoped>
.bg-DefModal {
  background: #566787;
}
</style>
